/*
 *
 * Copyright (c) 2026 Alexander Orlov.
 *
 */

import apiClient from './client';

export interface BookingViolationRow {
  citationNumber: string | null;
  amount: number;
  issueDateUtc: string;        // ISO 8601 UTC
  address: string | null;
  agency: string | null;
  status: string | null;
  payUrl: string | null;
  pluginKey: string | null;
  endpointKey: string | null;
  endpointDisplayName: string | null;
  distanceMiles: number;
}

export interface BookingViolationsResult {
  success: boolean;
  message?: string;
  bookingId: string;
  licensePlate: string;
  state: string;
  carLatitude: number;
  carLongitude: number;
  bookingFromUtc: string;
  bookingToUtc: string;
  radiusMiles: number;
  /** Always 0 — nothing is scraped at read time. Kept for wire compatibility. */
  scopesQueried: number;
  /** Freshest LastSeenAt across the rows; null when this car was never scanned. */
  lastScannedAtUtc: string | null;
  violations: BookingViolationRow[];
}

export const bookingViolationsApi = {
  /**
   * List the violations already found for a booking. This reads rows the background
   * fleet scan stored in dbo.Violations — it does NOT scrape, so it returns in
   * milliseconds and an empty list means "not scanned yet", not "none exist".
   * The radius filter lives on the scan side now.
   */
  getForBooking: async (bookingId: string): Promise<BookingViolationsResult> => {
    const { data } = await apiClient.get<BookingViolationsResult>(
      `/api/bookings/${bookingId}/violations`);
    return data;
  },
};
